import { render, staticRenderFns } from "./TestBuilderEdit.vue?vue&type=template&id=ddf8cefc&"
import script from "./TestBuilderEdit.vue?vue&type=script&lang=js&"
export * from "./TestBuilderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports